import videojs from "video.js";
import fr from "video.js/dist/lang/fr.json";

import ahoy from "ahoy.js";

import { setupPreviewLoop } from "~/javascript/utils/previewLoop.js";
import { setupCta } from "~/javascript/utils/videoCta.js";
//import { vjsdump } from "~/javascript/utils/vjsdump.js";

videojs.addLanguage('fr', {
  ...fr,
  "captions off": "Aucun",
});

/* Initialize the player */

const { previewLoopStart, previewLoopEnd, autoplay, loop, selfEmbed, poster, cta, aspectRatio } = window.player_settings;
let { previewLoop } = window.player_settings;

const isiOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
const isAndroid = !!navigator.userAgent && /(android)/i.test(navigator.userAgent);

previewLoop = previewLoop && !isiOS && !isAndroid;

const videoIdMeta = document.querySelector('meta[name=glob-video-id]');
const videoId = parseInt(videoIdMeta && videoIdMeta.content || 0);

const videoHashMeta = document.querySelector('meta[name=glob-video-hash]');
const videoHash = videoHashMeta && videoHashMeta.content || "";

const player = videojs("glob-video", {
  language: "fr",
  controls: true,
  controlBar: {
    volumePanel: { inline: false }
  },
  playbackRates: [0.75, 1, 1.25, 1.5, 2],
  autoplay: autoplay,
  muted: previewLoop || autoplay,
  aspectRatio,
  loop,
  poster,
  html5: {
    vhs: {
      bufferBasedABR: true,
      smoothQualityChange: true,
      handlePartialData: true,
      limitRenditionByPlayerDimensions: false,
    }
  }
});

player.qualityLevels().on('addqualitylevel', event => {
  const { qualityLevel } = event;
  const portrait = qualityLevel.width < qualityLevel.height;
  qualityLevel.enabled = portrait ? qualityLevel.width <= 1250 : qualityLevel.height <= 1250;
});

//vjsdump(player);

/* Setup tracking */
ahoy.configure({
  cookies: false,
  visitsUrl: "/pipe/visits",
  eventsUrl: "/pipe/events"
});

const stats = {
  videoId,
  selfEmbed,
  loaded: false,
  played: false,
  ctaViewed: false,
  ctaClicked: false,
  percentageWatched: [],
  secondsWatched: []
};

/* Initialize the unmute button */

if (previewLoop) {
  setupPreviewLoop(player, previewLoopStart, previewLoopEnd, stats);
}

/* Initialize the CTA button */

if (cta.show) {
  setupCta(player, cta, stats);
}

/* Setup stats */

player.on("loadeddata", () => {
  if (!selfEmbed && !stats.loaded) {
    ahoy.track("Loaded", { video_id: videoId });
    stats.loaded = true;
  }
});

player.on("play", () => {
  if (previewLoop && !player.hasClass("vjs-unmute-button-visible") || !previewLoop) {
    if (!stats.played) {
      const percentage = Math.floor(player.currentTime() / player.duration() * 100);
      !selfEmbed && ahoy.track("Pressed play", { video_id: videoId, percentage });
      stats.played = true;
    }
  }
});

let lastTime;

player.on("timeupdate", () => {
  if (previewLoop && !player.hasClass("vjs-unmute-button-visible") || !previewLoop) {
    const currentTime = player.currentTime();
    window.top.postMessage({
      globVideo: {
        currentTime,
        videoHash
      }
    }, "*");

    const percentage = Math.floor(currentTime / player.duration() * 100);
    if (!stats.percentageWatched[percentage] && lastTime != percentage) {
      // set the current second to true to flag it as watched, and track in Ahoy
      lastTime = percentage;
      stats.percentageWatched[percentage] = true;
      !selfEmbed && ahoy.track("Viewing", { video_id: videoId, percentage });
    }

    if (!player.paused()) {
      // set the current second to "1" to flag it as watched
      const currentTimeSecs = parseInt(player.currentTime());
      stats.secondsWatched[currentTimeSecs] = 1;

      // sum the value of the array (add up the "secondsWatched") and send it upstream
      const totalTime = stats.secondsWatched.reduce((acc, val) => acc + val, 0);
      window.top.postMessage({
        globVideoTotal: {
          totalTime,
          videoHash
        }
      }, "*");
    }
  }
});
